<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="headerId">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" :id="headerId">
            DNS Records
          </h4>
        </div>
        <div class="modal-body mb-0 px-3 px-md-5">
          <div v-if="domain" class="dns-records-wrapper">
            <table v-for="(record, i) of records" :key="i" class="dns-records-table" style="background-color: #fdfdfd;">
              <tr>
                <td class="label">
                  Record Type:
                </td>
                <td class="value">{{ record.record_type || record.type }}</td>
              </tr>
              <tr>
                <td class="label">
                  Record Name:
                </td>
                <td class="value" v-if="defaultSubdomain != ''">{{ record.name.replace(domain.name, defaultSubdomain) }}</td>
                <td class="value" v-else>{{ record.name }}</td>
              </tr>
              <tr>
                <td class="label">
                  Record Value:
                </td>
                <td class="value">{{ record.value }}</td>
              </tr>
            </table>

            <table v-for="(record, index) of mxRecords" :key="'mx' + index" class="dns-records-table">
              <tr>
                <td class="label">
                  Record Type:
                </td>
                <td class="value">
                  {{ record.type }}
                </td>
              </tr>
              <tr>
                <td class="label">
                  Record Name:
                </td>
                <td class="value" v-if="defaultSubdomain != ''">{{ record.name.replace(domain.name, defaultSubdomain) }}</td>
                <td class="value" v-else>{{ record.name }}</td>
              </tr>
              <tr>
                <td class="label">
                  Record Value:
                </td>
                <td class="value">
                  {{ record.value }}
                </td>
              </tr>
              <tr>
                <td class="label">
                  Priority:
                </td>
                <td class="value">
                  {{ record.priority }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {extractDnsMxRecords} from '../../../utility/dns/extractDnsMxRecords';

export default {
  name: 'email-domain-dns-modal',
  props: {
    domain: {
      type: Object,
    },
    defaultSubdomain: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modalId: 'email-domain-dns-modal',
      headerId: 'email-domain-dns-modal-header',
    };
  },
  watch: {
    domain: {
      immediate: true,
      handler(domain, previousDomain) {
        if (domain && !previousDomain) {
          $(`#${this.modalId}`).modal('show');
        }
      },
    },
  },
  computed: {
    allRecords() {
      return (this.domain && this.domain.dns) || [];
    },
    records() {
      return this.allRecords.filter(record => record.type !== 'MX');
    },
    mxRecords() {
      const mxRecords = extractDnsMxRecords(this.allRecords);
      if (mxRecords && mxRecords.length > 0) {
        return mxRecords;
      }

      if (this.domain && this.domain.name) {
        return [
          {type: 'MX', name: this.domain.name, priority: '10', value: 'mxa.mailgun.org'},
          {type: 'MX', name: this.domain.name, priority: '10', value: 'mxb.mailgun.org'},
        ];
      }

      return [];
    },
  },
  mounted() {
    $(`#${this.modalId}`).on('hidden.bs.modal', () => this.$emit('close-modal'));
  },
};
</script>

<style lang="scss" scoped>
button:hover {
  background-color: unset;
}

.dns-records-wrapper {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .dns-record-header {
    text-align: left;
    font-size: 20px;
    padding: 0 0 10px 0;
  }

  .dns-records-table,tr,td {
    border-collapse: collapse;
    text-align:left;
    border:1px solid #aaa;
    padding:0;
  }

  .dns-records-table {
    border:1px solid red;
    margin: 0 0 30px 0;

    tr {
      height:40px;
    }

    .label {
      height:40px;
      line-height:40px;
      color:#555;
      float:left;
      text-align:right;
      padding: 0 10px;
      border:none;
      width: 20%;
    }

    .value {
      height:40px;
      line-height:40px;
      padding: 0 15px;
      word-break: break-all;
      width: 80%;
    }
  }
}
</style>
